<template>
  <v-container>
    <v-row>
      <v-col>
        <div>
          <p class="headline primary--text">
            <span v-if="behaviour.title" class="font-weight-black">
              {{ behaviour.title + " " }}
            </span>
            <span v-if="!isSummaryView && behaviour.subtitle">
              {{ behaviour.subtitle(isSelfSurvey) }}
            </span>
          </p>
          <p v-if="!isSummaryView && behaviour.flavourText" class="font-italic">
            {{ behaviour.flavourText(isSelfSurvey) }}
          </p>
        </div>
        <div class="mt-10">
          <p class="title">
            <span v-html="this.questionText()" class="font-weight-light" />
          </p>
        </div>

         <!-- score for self -->
        <v-row
          class="d-none d-sm-inline-flex width-full question-options"
          justify="center"
          no-gutters
          v-if="isSelfSurvey"
        >
          <v-radio-group
            v-model="rating"
            :rules="[
              v =>
                currentStep !== this.$props.pageNr ||
                !!v ||
                this.isRatingSelected() ||
                'Please select rating.'
            ]"
            @change="manualValidateForm"
            row
            :disabled="isSummaryView"
          >
            <v-radio
              v-for="i in 6"
              :key="i"
              class="large-self question-option"
              on-icon="mdi-checkbox-marked-circle"
              color="primary"
              :value="i"
            />
          </v-radio-group>
        </v-row>

        <!-- score for peer (has NA option) -->
        <v-row
          class="d-none d-sm-inline-flex width-full question-options"
          justify="center"
          no-gutters
          v-if="!isSelfSurvey"
        >
          <v-radio-group
            v-model="rating"
            :rules="[
              v =>
                currentStep !== this.$props.pageNr ||
                !!v ||
                this.isRatingSelected() ||
                'Please select rating.'
            ]"
            @change="manualValidateForm"
            row
            :disabled="isSummaryView"
          >
            <v-radio
              v-for="i in 7"
              :key="i"
              class="large-peer question-option"
              on-icon="mdi-checkbox-marked-circle"
              color="primary"
              :value="i"
            />
          </v-radio-group>
        </v-row>

        <v-row
          class="d-flex d-sm-none width-full question-options-small"
          justify="center"
          no-gutters
          v-if="isSelfSurvey"
        >
          <v-radio-group
            v-model="rating"
            :rules="[
              v =>
                currentStep !== this.$props.pageNr ||
                !!v ||
                this.isRatingSelected() ||
                'Please select rating.'
            ]"
            @change="manualValidateForm"
            row
            :disabled="isSummaryView"
          >
            <v-radio
              v-for="i in 6"
              :key="i"
              class="small-self question-option"
              on-icon="mdi-checkbox-marked-circle"
              color="primary"
              :value="i"
            />
          </v-radio-group>
        </v-row>
        <v-row
          class="d-flex d-sm-none width-full question-options-small"
          justify="center"
          no-gutters
          v-if="!isSelfSurvey"
        >
          <v-radio-group
            v-model="rating"
            :rules="[
              v =>
                currentStep !== this.$props.pageNr ||
                !!v ||
                this.isRatingSelected() ||
                'Please select rating.'
            ]"
            @change="manualValidateForm"
            row
            :disabled="isSummaryView"
          >
            <v-radio
              v-for="i in 7"
              :key="i"
              class="small-peer question-option"
              on-icon="mdi-checkbox-marked-circle"
              color="primary"
              :value="i"
            />
          </v-radio-group>
        </v-row>

        <!-- label for peer -->
        <v-row
          class="d-none d-sm-inline-flex radio-bottom-labels caption width-full"
          v-if="!isSelfSurvey"
        >
          <div class="text-center adj-label adj-label-large-peer">None of the time</div>
          <div class="text-center adj-label adj-label-large-peer">Very few times</div>
          <div class="text-center adj-label adj-label-large-peer">Some of the time</div>
          <div class="text-center adj-label adj-label-large-peer">Many times</div>
          <div class="text-center adj-label adj-label-large-peer">Most of the time</div>
          <div class="text-center adj-label adj-label-large-peer">All of the time</div>
          <div class="text-center adj-label adj-label-large-peer">Not Applicable</div>
        </v-row>

        <!-- label for self -->
        <v-row
          class="d-none d-sm-inline-flex radio-bottom-labels caption width-full"
          v-if="isSelfSurvey"
        >
          <div class="text-center adj-label adj-label-large-self">None of the time</div>
          <div class="text-center adj-label adj-label-large-self">Very few times</div>
          <div class="text-center adj-label adj-label-large-self">Some of the time</div>
          <div class="text-center adj-label adj-label-large-self">Many times</div>
          <div class="text-center adj-label adj-label-large-self">Most of the time</div>
          <div class="text-center adj-label adj-label-large-self">All of the time</div>
        </v-row>

        <!-- label for peer - mobile -->
        <v-row class="d-sm-none radio-bottom-labels caption width-full" v-if="!isSelfSurvey">
          <div class="text-center adj-label adj-label-large-peer">None of the time</div>
          <div class="text-center adj-label adj-label-large-peer">Very few times</div>
          <div class="text-center adj-label adj-label-large-peer">Some of the time</div>
          <div class="text-center adj-label adj-label-large-peer">Many times</div>
          <div class="text-center adj-label adj-label-large-peer">Most of the time</div>
          <div class="text-center adj-label adj-label-large-peer">All of the time</div>
          <div class="text-center adj-label adj-label-large-peer">N/A</div>
        </v-row>

        <!-- label for self - mobile -->
        <v-row class="d-sm-none radio-bottom-labels caption width-full" v-if="isSelfSurvey">
          <div class="text-center adj-label adj-label-large-self">None of the time</div>
          <div class="text-center adj-label adj-label-large-self">Very few times</div>
          <div class="text-center adj-label adj-label-large-self">Some of the time</div>
          <div class="text-center adj-label adj-label-large-self">Many times</div>
          <div class="text-center adj-label adj-label-large-self">Most of the time</div>
          <div class="text-center adj-label adj-label-large-self">All of the time</div>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Behaviour',

  props: ['behaviour', 'field', 'pageNr', 'isSummaryView'],

  data() {
    return {
      ratingField: `${this.field}_Rating`,
    };
  },

  methods: {
    storeResponse(responseField, responseValue) {
      this.$store.commit('storeResponse', responseField, responseValue);
    },
    isRatingSelected() {
      const ratingValue = this.$store.state.response[this.ratingField];
      return ratingValue !== undefined && ratingValue !== null;
    },
    questionText() {
      if (this.behaviour.questionText) {
        return this.behaviour.questionText(this.isSelfSurvey, this.params);
      }

      if (this.isSelfSurvey) {
        return `How often have you seen yourself demonstrate <strong>${this.behaviour.title}</strong>?`;
      }

      return `How often have you seen <span class="primary--text">${this.params.EvaluateeFullName}</span> demonstrate <strong>${this.behaviour.title}</strong>?`;
    },
    manualValidateForm() {
      this.$emit('validate-form');
    },
  },

  computed: {
    ...mapGetters(['currentStep', 'isSelfSurvey']),
    params() {
      return this.$store.state.params;
    },
    rating: {
      get() {
        return this.$store.state.response[this.ratingField];
      },
      set(newValue) {
        this.$store.commit('storeResponse', {
          k: this.ratingField,
          v: newValue,
        });
      },
    },
  },
};
</script>

<style>
.v-input__control {
  width: 100% !important;
}

.question-options .v-icon.v-icon {
  font-size: 48px !important;
}

.question-options-small .v-icon.v-icon {
  font-size: 25px !important;
}

.v-input--selection-controls__ripple {
  left: 0px !important;
}

@media (max-width: 599px) {
  .v-input--selection-controls__ripple {
    left: -12px !important;
  }
}

.v-input__slot {
  margin-bottom: 0px !important;
}
</style>

<style scoped>
.adj-label {
  padding: 0 5px;
  line-height: normal;
}
.adj-label-large-peer {
  width: 14%;
}
.adj-label-large-self {
  width: 16%;
}

@media (max-width: 599px) {
  .adj-label-large-self {
    padding: 0;
  }
}

.small.v-radio {
  margin-right: 0px;
}

.question-option.v-radio {
  margin-right: 0px !important;
  display: unset !important;
  text-align: center;
}

.large-peer.v-radio {
  width: 14%;
}

.large-self.v-radio {
  width: 16%;
}

.small-self.v-radio {
  width: 16%;
}

.small-peer.v-radio {
  width: 14%;
}

.v-input {
  width: 100%;
}

.width-full {
  width: 100%;
}

.radio-bottom-labels {
  margin-top: -40px;
  margin-left: 2.5px;
}

.adj-label-small {
  margin: 0px;
}

@media (max-width: 599px) {
  .caption {
    margin-top: -10px;
  }
  .radio-bottom-labels {
    margin-left: -2.5px;
  }
}
</style>
